import { AvatarBadge, Box, Button, Divider, Flex, Grid, GridItem, Menu, MenuButton, MenuItem, MenuList, Tooltip, useColorModeValue, useDisclosure, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { List, WhatsappLogo } from '@phosphor-icons/react'
import { State } from "state/reducers"

import Layout from 'components/ManagerLayout'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import ActiveLife from './ActiveLife'
import Folders from './components/folders'
import LifeDetails from './components/LifeDetails'
import Assessments from './components/Assessments'
import { useGetLife } from 'hooks/useLives'
import SendMessage from './components/SendMessage'
import { useSelector } from 'react-redux'
import { Roles } from 'enums/roles'

const ViewLife = () => {
    const auth = useSelector(({ auth }: State) => auth)

    const { id } = useParams()
    const { loading, data } = useGetLife(String(id));
    const navigate = useNavigate()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { isOpen: sendMessageOpen, onOpen: onOpenSendMessage, onClose: onCloseSendMessage } = useDisclosure();
    const status = true;

    const isSuperAdmin = auth.role.name === Roles.SUPER_ADMIN;

    const iconColor = useColorModeValue('#FFF', '#000')

    const life = data?.getLife || {};

    return (
        <Layout>
            <Grid
                templateColumns={{ sm: "1fr", md: "repeat(1, 1fr 2fr)" }}
                templateRows={{ sm: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                gap="12px"
                w={"100%"}
                pt={{ sm: "12px", lg: "12px" }}
            >
                <GridItem>
                    {
                        loading || life.next_event == null ?
                            <></>
                        : <Assessments nextEvent={life.next_event} />
                    }
                    <Card
                        px="0px"
                        pt="0"
                        pb="22px"
                        minHeight="100px"
                        maxHeight="800px"
                        overflowX={{ sm: "auto", lg: "unset" }}
                    >
                        <CardBody h="100%" px="22px">
                            <VStack spacing={8} w="full">
                                <Flex w="full" justifyContent="center" alignItems="center" position="relative" mb="4">
                                    <Box position="absolute" top={0} right={0} pt="4" hidden={loading}>
                                        {
                                            isSuperAdmin &&
                                                <Button onClick={() => onOpenSendMessage()} mr="6px" colorScheme="green" leftIcon={<WhatsappLogo size="24px" weight="bold" color={iconColor} />} >
                                                    Enviar Mensagem
                                                </Button>
                                        }
                                        <Menu>
                                            <MenuButton as={Button} colorScheme="green">
                                                <List size="20px" weight="bold" />
                                            </MenuButton>
                                            <MenuList>
                                                <MenuItem onClick={() => navigate('editar')}>Editar</MenuItem>
                                                {
                                                    isSuperAdmin && <MenuItem onClick={() => onOpenSendMessage()}>Enviar Mensagem</MenuItem>
                                                }
                                                <MenuItem onClick={onOpen}>{status ? 'Desativar' : 'Ativar'}</MenuItem>
                                            </MenuList>
                                        </Menu>
                                    </Box>
                                    {/* <Avatar /> */}
                                </Flex>
                                <LifeDetails life={life} isLoading={loading} />
                            </VStack>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem>
                    <Folders life={life} isLoading={loading} />
                </GridItem>
            </Grid>
            <ActiveLife isOpen={isOpen} onClose={onClose} status={status} />
            <SendMessage isOpen={sendMessageOpen} onClose={onCloseSendMessage} id="" />
        </Layout >
    )
}

export default ViewLife